export * from '@primeuix/themes/lara/blockui';
export { default } from '@primeuix/themes/lara/blockui';
